/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetWaitTimeEstimateRequest} from '@cash-web/protos/squareup/cash/supportal/service.pb'
import {GetWaitTimeEstimateResponse} from '@cash-web/protos/squareup/cash/supportal/service.pb'


export const getWaitTimeEstimate = (request:GetWaitTimeEstimateRequest, options?: CashRequestOptions) => post<GetWaitTimeEstimateRequest, GetWaitTimeEstimateResponse>("/2.0/cash/get-wait-time-estimate", request, {...options, rejectOnError: true })